import React from "react";
import { Link } from "react-router-dom";
import { resolveBannerPresentation } from "constants/siteHeaderMessageStyle";

const KIND_LABELS = {
  promotion: "Promotion",
  maintenance: "Maintenance",
  update: "Update",
  info: "Info",
};

function formatUpdateDate(ymd) {
  if (!ymd) return "";
  const s = String(ymd).slice(0, 10);
  const [y, m, d] = s.split("-");
  if (!y || !m || !d) return s;
  return `${d}/${m}/${y}`;
}

function BannerLine({ row }) {
  const kind = String(row.kind || "info").toLowerCase();
  const label = KIND_LABELS[kind] || "Info";
  const updateLabel = formatUpdateDate(row.updateDate);
  const { barStyle, textStyle, textAlign, flexJustify, useKindClass } =
    resolveBannerPresentation(row);

  const linkUrl = String(row.linkUrl || "").trim();
  const linkLabel = String(row.linkLabel || "").trim() || "Learn more";
  const isExternal = /^https?:\/\//i.test(linkUrl);

  return (
    <div
      className={`border-b border-black/10 px-4 py-2 ${useKindClass ? "bg-white/10" : ""}`}
      style={barStyle}
      role="status"
    >
      <div
        className="mx-auto flex w-full max-w-6xl flex-wrap items-center gap-x-2 gap-y-1"
        style={{
          justifyContent: flexJustify,
          textAlign,
        }}
      >
        <span
          className="rounded-md bg-black/15 px-2 py-0.5 text-xs font-bold uppercase tracking-wide"
          style={textStyle}
        >
          {label}
        </span>
        {updateLabel ? (
          <span className="font-semibold tabular-nums" style={textStyle}>
            {updateLabel}
          </span>
        ) : null}
        <span className="max-w-4xl font-medium" style={textStyle}>
          {row.message}
        </span>
        {linkUrl ? (
          isExternal ? (
            <a
              href={linkUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="underline underline-offset-2 hover:opacity-90"
              style={textStyle}
            >
              {linkLabel}
            </a>
          ) : (
            <Link
              to={linkUrl}
              className="underline underline-offset-2 hover:opacity-90"
              style={textStyle}
            >
              {linkLabel}
            </Link>
          )
        ) : null}
      </div>
    </div>
  );
}

export default function SiteHeaderBanner({ messages = [] }) {
  if (!messages.length) return null;

  return (
    <div className="w-full" aria-label="Site announcements">
      {messages.map((row) => (
        <BannerLine key={row.id} row={row} />
      ))}
    </div>
  );
}

/** ~2.25rem per banner line for layout padding */
export function siteHeaderBannerOffsetRem(count) {
  const n = Math.max(0, Number(count) || 0);
  return n * 2.25;
}
